import axios from 'axios';
import * as _ from 'lodash';
import { store } from '../redux/store';
import { authActions } from '../redux/auth/authSlice';
import { createNewAccessToken } from './authApi';
import { Platform } from '../utils/enums/platform-type.enum';
import { modelAction } from '../redux/models/modelsSlice';

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_CLOUD_URL,
    withCredentials: true,
    headers: {
      platform: Platform.SAAS,
    },
  });

  // Response interceptor
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const initialRequest = error.config;

      // Check if the req is generate new access token and it gets 400 res,
      // should need to log out the user or If the second request also gets unauthorized, log out the user
      if (
        (error.response && error.response.status === 401 && error.request?.responseURL.includes('auth/access-token')) ||
        (error.response && error.response.status === 401 && initialRequest._retry)
      ) {
        store.dispatch(authActions.setLogInStatus(false));
        store.dispatch(authActions.clearComponentStatus());
        store.dispatch({ type: 'CLEAR_STORE' });
      }

      // Check if the response status code is 401 (unauthorized)
      else if (
        error.response &&
        error.response.status === 401 &&
        !['auth/login'].some((url) => error.request.responseURL.includes(url)) &&
        !initialRequest._retry
      ) {
        initialRequest._retry = true; // Mark the request as already retried

        try {
          // Create new access token
          await createNewAccessToken();

          // Retry the original request with the new access token
          return instance(initialRequest);
        } catch (refreshError) {
          // Handle the error when refreshing the token fails
          if (_.get(refreshError, 'response.status') === 400) {
            store.dispatch(authActions.setLogInStatus(false));
            store.dispatch(authActions.clearComponentStatus());
            store.dispatch({ type: 'CLEAR_STORE' });
          }
          return Promise.reject(refreshError);
        }
      }

      if (error.response && error.response.status === 403) {
        store.dispatch(modelAction.setIsPermissionDeniedModelOpen(true));
      }

      // Return any other errors
      return Promise.reject(error);
    },
  );

  return instance;
};

export const backendApiInstance = createAxiosInstance();
